import React from 'react';
import { SvgProps } from 'react-native-svg';

import EightIcon from './eight';
import FiveIcon from './five';
import FourIcon from './four';
import NineIcon from './nine';
import OneIcon from './one';
import SevenIcon from './seven';
import SixIcon from './six';
import TenIcon from './ten';
import ThreeIcon from './three';
import TwoIcon from './two';

export const NUMBER_ICON_MAP: Record<number, React.FC<SvgProps>> = {
    1: OneIcon,
    2: TwoIcon,
    3: ThreeIcon,
    4: FourIcon,
    5: FiveIcon,
    6: SixIcon,
    7: SevenIcon,
    8: EightIcon,
    9: NineIcon,
    10: TenIcon,
};
